import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";

export default class Price extends React.Component {
  render() {
    const { className, price, newComingPrice } = this.props;
    const withNewComingPrice = !!(newComingPrice || newComingPrice === 0);
    const cn = cx({
      [className]: true,
      "product-price": true,
      "product-price--new-coming": withNewComingPrice,
    });
    const priceInYen = Math.max(Math.ceil(price / 100) || 0, 0);
    const salePriceInYen = withNewComingPrice && Math.max(Math.ceil(newComingPrice / 100) || 0, 0);

    return (
      <div className={cn}>
        {!withNewComingPrice || (
          <span className="product-price__group product-price__group--new-coming">
            <span className="product-price__label product-price__label--prefix">新人价：</span>
            <span className="product-price__price">¥{salePriceInYen}</span>
            <span className="product-price__label product-price__label--suffix">起</span>
          </span>
        )}
        <span className="product-price__group product-price__group--original">
          {!withNewComingPrice || <span className="product-price__label product-price__label--prefix">原价：</span>}
          {React.createElement(
            withNewComingPrice ? "del" : "span",
            { className: "product-price__price" },
            `¥${priceInYen}`
          )}
        </span>
      </div>
    );
  }
}

Price.defaultProps = {
  className: "",
  newComingPrice: undefined,
};

Price.propTypes = {
  className: PropTypes.string,
  price: PropTypes.number.isRequired,
  newComingPrice: PropTypes.number,
};

require("./price.less");